import $ from 'jquery';
import 'url-search-params-polyfill';
import Vue from 'vue/dist/vue';
import { uniqBy } from 'lodash';

class Offers {
  constructor (props) {
    if (!props.el) return

    this.el = props.el;

    this.initVue()
  }

  initVue() {
    new Vue({
      el: this.el,
      data: {
        loading: true,
        end: false,
        offset: 0,
        limit: OFFERS_LIST_LIMIT,
        currentFilters: [],
        filters: {
          typeOfEmployment: [],
          department: [],
          typeOfContract: [],
        },
        offers: [],
        offersOriginal: [],
      },
      mounted() {
        const filtersList = this.$el.querySelectorAll('.b-offers__filter__list')
        filtersList.forEach(filter => {
          filter.removeAttribute('style')
        })

        if (window.innerWidth < 740) {
          const fakeselect = this.$el.querySelector('.b-offers__filter--fakeselect')
          const closeFilters = this.$el.querySelector('.b-offers__closeFilters')

          fakeselect.addEventListener('click', () => {
            fakeselect.classList.toggle('active');
          })

          closeFilters.addEventListener('click', () => {
            fakeselect.classList.remove('active');
          })
        }

        this.getOffers();
      },
      methods: {
        // Get offers list
        getOffers() {
          const data = {};

          const searchParams = new URLSearchParams(window.location.search);
          if (searchParams.has('nocache')) {
            data.nocache = true;
          }

          $.ajax({
            url:
              window.baseurl +
              '/wp-json/smartrecruiters/v1/offers',
            method: 'GET',
            data: data,
            success: (results) => {
              this.offers = this.offers.concat(results);
              this.offersOriginal = this.offers
              this.offset += results.length;
              this.end = results.length == 0;

              this.setupFilters()
              this.getJobsByHash();
            },
          }).always(() => {
            this.loading = false;
          });
        },

        getJobsByHash() {
          if (!window.location.hash) return;

          const hash = this.sanitize(decodeURI(window.location.hash).replace('#', ''));

          this.filterOffersByLabel(hash, 'department')
        },

        setupFilters() {
          // Prepare each filters
          this.offers.forEach(offer => {
            this.filters.typeOfEmployment.push({
              id: offer.typeOfEmployment.id,
              label: offer.typeOfEmployment.label,
              checked: false,
              show: true,
              offers: [],
            })

            this.filters.department.push({
              id: offer.department.id,
              label: offer.department.label,
              checked: false,
              show: true,
              offers: [],
            })

            this.filters.typeOfContract.push({
              id: offer.typeOfContract.id,
              label: offer.typeOfContract.label,
              checked: false,
              show: true,
              offers: [],
            })
          });

          // Remove duplicate filters
          this.filters.typeOfEmployment = uniqBy(this.filters.typeOfEmployment, 'id')
          this.filters.department = uniqBy(this.filters.department, 'id')
          this.filters.typeOfContract = uniqBy(this.filters.typeOfContract, 'id')

          // Push offer ids according to filter
          this.offers.forEach(offer => {
            this.filters.typeOfEmployment.forEach(filter => {
              if (offer.typeOfEmployment.id == filter.id) {
                filter.offers.push(offer.id)
              }
            })

            this.filters.department.forEach(filter => {
              if (offer.department.id == filter.id) {
                filter.offers.push(offer.id)
              }
            })

            this.filters.typeOfContract.forEach(filter => {
              if (offer.typeOfContract.id == filter.id) {
                filter.offers.push(offer.id)
              }
            })
          })
        },

        filterOffers(filterId, filterType) {
          // Set current filters
          this.filters[filterType].forEach(item => {
            if (item.id == filterId) {
              item.checked = !item.checked

              if (item.checked) {
                this.currentFilters.push(item)
              } else {
                this.currentFilters = this.currentFilters.filter(filter => filter.id !== item.id)
              }
            }
          })

          // Filter offers from current filters
          if (this.currentFilters.length > 0) {
            this.currentFilters.forEach((item) => {
              this.offers = this.offersOriginal.filter((offer) => item.offers.includes(offer.id))
            })
          } else {
            this.offers = this.offersOriginal
          }

          // Check if other filters have offers
          Object.values(this.filters).forEach((type) => {
            type.forEach(item => {
              item.show = this.offers.filter((offer) => item.offers.includes(offer.id)).length > 0
            })
          })
        },

        filterOffersByLabel(filterLabel, filterType) {
          // Set current filters
          this.filters[filterType].forEach(item => {
            if (this.sanitize(item.label) == filterLabel) {
              item.checked = !item.checked

              if (item.checked) {
                this.currentFilters.push(item)
              } else {
                this.currentFilters = this.currentFilters.filter(filter => filter.id !== item.id)
              }
            }
          })

          // Filter offers from current filters
          if (this.currentFilters.length > 0) {
            this.currentFilters.forEach((item) => {
              this.offers = this.offersOriginal.filter((offer) => item.offers.includes(offer.id))
            })
          } else {
            this.offers = this.offersOriginal
          }

          // Check if other filters have offers
          Object.values(this.filters).forEach((type) => {
            type.forEach(item => {
              item.show = this.offers.filter((offer) => item.offers.includes(offer.id)).length > 0
            })
          })
        },

        sanitize(str) {
          return str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s/g, '-')
        },
      },
    })
  }
}

let blockDOM
let blockArray = []

function init () {
  blockDOM = document.querySelectorAll('#app-offers')

  blockDOM.forEach((el) => {
    blockArray.push(new Offers({ el }))
  })
}

export const OFFERS_LIST_LIMIT = 5;

export default {
  init,
  Offers,
}



// WEBPACK FOOTER //
// ./scripts/components/Offers.js